<template>
    <div class="gap-sm grid grid-cols-3">
        <OrganizationCard
            v-for="org in props.sortedOrgs"
            :key="org.organization_id"
            :name="org.name ?? 'Not found'"
            :tag="org.name"
            :description="org.description ?? 'asdf  '"
            :users="org.users_count"
            :devices="org.devices_count"
            @click="routeToDetails(org.organization_id)"
        />
    </div>
</template>

<script setup lang="ts">
import type { AdminOrganizationData } from '@/stores/store-interfaces';
import OrganizationCard from '@/components/admin/organization/organization-card.vue';
import router from '@/router/admin-router';

const props = defineProps({
    isLoading: Boolean,
    sortedOrgs: Array<AdminOrganizationData>,
    sortColumn: String,
    sortDirection: Boolean,
});

function routeToDetails(id: number) {
    emit('choose', id);
    router.push({ name: 'org-detail', params: { id: id } });
}

const emit = defineEmits(['sort', 'choose']);
</script>
